var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mit-app-menu"},[_c('v-navigation-drawer',{attrs:{"app":"","permanent":"","clipped":""}},[(_vm.userModel)?_c('MitMenu',{attrs:{"userModel":_vm.userModel,"userRoles":_vm.userRoles},on:{"logout":_vm.logout,"login":_vm.login}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }